<template>
    <div>
        <Breadcrumb v-if="!buildYourJewelMode"></Breadcrumb>
        <h3 class="stones-title">{{ $t('stones_category') }}</h3>
        <div :class="{ 'labgrown': query.labgrown }" id="loading-table-container" class="stone-list container-fluid">
            <BuildYourJewelSelectedStones v-if="buildYourJewelMode && buildYourJewelStonesNumber > 1"
                @changeSelectedStones="search"></BuildYourJewelSelectedStones>
            <StoneFilters
                v-if="!buildYourJewelMode || buildYourJewelStonesNumber == 1 || buildYourJewelSelectedStones.length == 0"
                :buildYourJewelMode="buildYourJewelMode" @changeFilters="search"></StoneFilters>
            <div class="row mt-3" v-if="results.length == 0 && !isLoading">
                <div class="col-12 mb-5" v-if="!buildYourJewelMode">
                    {{ $t('stones.no_results') }} </div>
                <div class="col-12 mt-3" v-if="buildYourJewelMode && buildYourJewelStonesNumber > 1 && buildYourJewelSelectedStones.length < buildYourJewelStonesNumber">
                    <div>{{ $t('build_your_jewel.no_pairs') }}</div>
                    <button class="edit-diamond-btn btn btn-primary mt-3 mb-5" @click="setSelectedStones([])">{{ $t('build_your_jewel.edit_diamond') }}</button>
                </div>
            </div>

            <div class="row mt-3"
                v-if="results.length > 0 && (!buildYourJewelMode || buildYourJewelStonesNumber == 1 || buildYourJewelSelectedStones.length < buildYourJewelStonesNumber)">
                <div class="col-12">
                    <ve-table :class="{ 'stones-table': isLoading }" :columns="visibleColumns" :table-data="results"
                        :row-style-option="rowStyleOption" :cell-style-option="cellStyleOption"
                        :eventCustomOption="{ bodyRowEvents }" :cellSelectionOption="{ enable: false }"
                        row-key-field-name="id" :expandOption="expandOption"></ve-table>
                </div>
                <div class="col-12" v-if="total > 0">
                    <div class="stones-pagination">
                        <ve-pagination :page-index="pageIndex" @on-page-number-change="pageNumberChange" :total="total"
                            :page-size="pageSize" :layout="['prev', 'pager', 'next']" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StoneFilters from './StoneFilters.vue';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Breadcrumb from "./Breadcrumb.vue";
import StoneListExpandedRow from './StoneListExpandedRow.vue';
import BuildYourJewelSelectedStones from "./BuildYourJewelSelectedStones.vue";
import Vue from "vue";

export default {
    name: "StoneList",
    props: {
        buildYourJewelMode: String,
    },
    components: { StoneFilters, Breadcrumb, BuildYourJewelSelectedStones },
    data() {
        return {
            pageSize: 50,
            pageIndex: 1,
            expandOption: {
                trigger: "row",
                render: ({ row, column, rowIndex }, h) => {
                    return <StoneListExpandedRow row={ row } />;
                },
                expandedRowKeys: [],
                afterExpandRowChange: ({ afterExpandedRowKeys, row, rowIndex }) => {
                    this.changeExpandedRowKeys(row);
                },
            },
            rowStyleOption: { clickHighlight: true, stripe: true },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => { return "header-cell-gi"; },
                bodyCellClass: ({ column, rowIndex }) => { return "row-cell-gi"; },
            },
            columns: [
                { key: "a", title: this.$t('stones.shape'), align: "left", renderBodyCell: ({ row }, h) => { return row.diamond.certificate.shape; } },
                { key: "b", title: this.$t('stones.carat'), align: "left", renderBodyCell: ({ row }, h) => { return row.diamond.certificate.carats; } },
                { key: "c", title: this.$t('stones.color'), align: "left", renderBodyCell: ({ row }, h) => { return row.color; } },
                { key: "d", title: this.$t('stones.clarity'), align: "left", renderBodyCell: ({ row }, h) => { return row.diamond.certificate.clarity; } },
                { key: "e", title: this.$t('stones.certificateLab'), align: "left", renderBodyCell: ({ row }, h) => { return row.diamond.certificate.lab; } },
                { key: "f", title: this.$t('stones.cut'), align: "left", renderBodyCell: ({ row }, h) => { return this.$t("stones.quality." + row.diamond.certificate.cut); } },
                { key: "g", title: this.$t('stones.polish'), align: "left", renderBodyCell: ({ row }, h) => { return this.$t("stones.quality." + row.diamond.certificate.polish); } },
                { key: "h", title: this.$t('stones.symmetry'), align: "left", renderBodyCell: ({ row }, h) => { return this.$t("stones.quality." + row.diamond.certificate.symmetry); } },
                { key: "i", title: this.$t('stones.fluorescence'), align: "left", renderBodyCell: ({ row }, h) => { return this.$t("stones.fluorescence." + row.diamond.certificate.floInt); } },
                { key: "l", title: this.$t('stones.measurements'), align: "left", renderBodyCell: ({ row }, h) => { return this.formatNumberWithTwoDecimals(row.diamond.certificate.length) + 'x' + this.formatNumberWithTwoDecimals(row.diamond.certificate.width) + 'x' + this.formatNumberWithTwoDecimals(row.diamond.certificate.depth); } },
                { key: "m", title: this.$t('stones.discount'), align: "left", renderBodyCell: ({ row }, h) => { return this.formatNumberWithTwoDecimals((-Math.abs(row.discount)) / 100) + '%' } },
                { key: "n", title: this.$t('stones.price'), align: "left", renderBodyCell: ({ row }, h) => { return this.$options.filters.currency(row.cartItem.singleAmount * this.retailPerc * this.vat) } },
                { key: "o", title: this.$t('build_your_jewel.jewel_price'), align: "left", renderBodyCell: ({ row }, h) => { return  row.buildYourJewelPrice? (this.$t("from") + " " + this.$options.filters.currency(row.buildYourJewelPrice * this.retailPerc * this.vat)) : '' } },
                { key: "p", title: "", align: "center", type: "expand", width: 50 },
            ],
            loadingInstance: null,
            breakpoints: {
                md: ['a', 'b', 'c', 'd', 'e', 'f', 'm', 'n', 'o', 'p'],
                lg: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'm', 'n', 'o', 'p']
            },
            visibleColumns: []
        }
    },
    computed: {
        ...mapState({
            isLoading: (state) => state.stones.isLoading,
            results: (state) => state.stones.results,
            selectedStone: (state) => state.stones.selectedStone,
            total: (state) => state.stones.total,
            query: (state) => state.stones.query,
            retailPerc: (state) => state.detail.retailPerc,
            vat: (state) => state.detail.vat,
            credential: (state) => state.config.credential,
            buildYourJewelSelectedStones: (state) => state.buildYourJewel.selectedStones,
            buildYourJewelStonesNumber: (state) => state.buildYourJewel.stonesNumber,
        })
    },
    methods: {
        ...mapGetters("buildYourJewel", ["showBuildYourJewelPrice"]),
        ...mapActions("stones", [
            "selectStone",
            "fetchResults",
            "initResults",
            "resetResults",
        ]),
        ...mapMutations("buildYourJewel", [
            "setSelectedStones"
        ]),
        bodyRowEvents: function ({ row, rowIndex }) {
            return {
                click: (event) => {
                    row.cartItem.deliveryDate = Vue.formatShipmentDate(row.cartItem.deliveryDate);
                    this.selectStone(row);
                },
            };
        },
        changeExpandedRowKeys(row) {
            if (this.expandOption.expandedRowKeys.includes(row.id))
                this.expandOption.expandedRowKeys = [];
            else
                this.expandOption.expandedRowKeys = [row.id];
            Vue.setHeight();
        },
        scrollTo(height) {
            window.parent.postMessage(
                {
                    func: "setGioielleriaItalianaScroll",
                    message: height,
                },
                "*"
            );
        },
        searchCallback() {
            this.setVisibleColumns();
            this.loadingInstance.close();
            if (!this.buildYourJewelMode)
                this.scrollToTable();
            else
                this.scrollTo(0);
            Vue.setHeight();
        },
        scrollToTable() {
            let el = document.getElementById("loading-table-container");
            let h = el.offsetTop;
            this.scrollTo(h);
        },
        pageNumberChange(pageIndex) {
            this.scrollToTable();
            this.expandOption.expandedRowKeys = [];
            Vue.setHeight();
            this.pageIndex = pageIndex;
            this.loadingInstance.show();
            this.fetchResults({ order: this.query.order, query: this.query, limit: this.pageSize, offset: (pageIndex - 1) * this.pageSize, cb: this.searchCallback });
        },
        search() {
            this.expandOption.expandedRowKeys = [];
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#loading-table-container"),
                name: "wave",
                color: window.getComputedStyle(document.documentElement).getPropertyValue('--primary-color-1'),
            });
            this.loadingInstance.show();
            this.pageIndex = 1;
            this.initResults({ order: this.query.order, query: this.query, limit: this.pageSize, cb: this.searchCallback });
        },
        formatNumberWithTwoDecimals(number) {
            return this.$options.filters.number(parseFloat(number), '0.00');
        },
        setVisibleColumns: function () {
            if (window.innerWidth < 768) {
                this.visibleColumns = this.columns.filter(c => this.breakpoints.md.includes(c.key))
            } else if (window.innerWidth < 992) {
                this.visibleColumns = this.columns.filter(c => this.breakpoints.lg.includes(c.key))
            } else {
                this.visibleColumns = this.columns
            }
            if (this.query.fancy || this.retailPerc > 1 || !this.credential.apiEncryptedUser) {
                this.visibleColumns = this.visibleColumns.filter(c => c.key != "m")
            }

            if (this.buildYourJewelMode) {
                this.visibleColumns = this.visibleColumns.filter(c => c.key != "n")
            }

            if (!this.showBuildYourJewelPrice()) {
                this.visibleColumns = this.visibleColumns.filter(c => c.key != "o")
            } 
        },
    },
    created() {
        this.resetResults();
        window.addEventListener("resize", Vue.setHeight);
    },
    mounted() {
        if (!this.buildYourJewelMode)
            this.scrollToTable();
        else
            this.scrollTo(0);
        this.setVisibleColumns();
        window.addEventListener('resize', this.setVisibleColumns)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.setVisibleColumns)
    }
}

</script>

<style lang="scss" scoped>
.stone-list {
    background-color: #F0F0EF;
    position: relative;
}

::v-deep .header-cell-gi {
    background-color: var(--primary-color-1) !important;
    color: white !important;
}

::v-deep .row-cell-gi {
    cursor: pointer;
}

::v-deep .ve-table-tr-highlight td {
    background-color: var(--secondary-color-1) !important;
}


@media only screen and (max-width: 1200px) {
    ::v-deep .row-cell-gi {
        font-size: 12px !important;
    }

    ::v-deep .header-cell-gi {
        font-size: 12px !important;
    }
}

.stones-pagination {
    background-color: white;
    text-align: right;
    padding: 20px 0px;
    margin-bottom: 20px;
}

.stones-table {
    min-height: 400px;
}

.stones-title {
    font-family: var(--secondary-font-family);
    padding: 20px;
    text-transform: uppercase;
}

::v-deep .labgrown {
    .header-cell-gi {
        background-color: var(--labgrown-color) !important;
        color: white !important;
    }

    .vue-slider-process {
        background-color: var(--labgrown-color) !important;
    }

    .stone-shape.active {
        border: 2px solid var(--labgrown-color);
    }

    .stone-expanded-row .price-div {
        border-color: var(--labgrown-color);
    }

    .v-select {
        --vs-selected-bg: var(--labgrown-color);
        --vs-selected-color: #eeeeee;

        .vs__deselect {
            background-color: transparent !important;
        }
    }

    .white-fancy-btn .btn-primary.active {
        background-color: var(--labgrown-color) !important;
    }

    .stone-image-div iframe {
        border: 4px solid var(--labgrown-color);
        display: flex;
        border-radius: 10px;
    }
}

.edit-diamond-btn {
    background-color: var(--primary-color-1) !important;
    color: white !important;
    text-transform: uppercase;
}
</style>